import { request, RespError, handleFormatRes } from '../../utils';
import { QRY_EXCHANGE_PRIZE_RESULT } from '../../config/url';
/** 异步兑换结果 */
export var AsyncExchangePrizeResult;
(function (AsyncExchangePrizeResult) {
    /** 未查询到，需继续查询 */
    AsyncExchangePrizeResult[AsyncExchangePrizeResult["notFound"] = 0] = "notFound";
    /** 兑换成功 */
    AsyncExchangePrizeResult[AsyncExchangePrizeResult["success"] = 1] = "success";
    /** 兑换失败-限额 */
    AsyncExchangePrizeResult[AsyncExchangePrizeResult["limtFail"] = 2] = "limtFail";
    /** 兑换失败-其他 */
    AsyncExchangePrizeResult[AsyncExchangePrizeResult["otherFail"] = 3] = "otherFail";
})(AsyncExchangePrizeResult || (AsyncExchangePrizeResult = {}));
// 需要转成 int 型的 key 数组
const needParseIntKey = ['status'];
// 需要转成 date 型的 key 数组
const needParseDateKey = [];
/**
 * 查询奖品兑换结果接口
 *
 * 通过异步奖品兑换流水ID，查询异步兑换结果
 *
 * 接口地址：`/app/promotion/prom_qry_async_exchange_res.cgi`
 *
 * @param actListid 商品发放活动id
 * @param exchangeListId 异步兑换时返回的兑换流水id
 * @returns
 */
export async function qryExchangePrizeResult({ actListid, exchangeListId, }) {
    try {
        // 参数格式化
        const params = {
            act_listid: actListid,
            list_id: exchangeListId,
        };
        // 接口请求
        const result = await request.get(QRY_EXCHANGE_PRIZE_RESULT, { params });
        if (result) {
            // 正常的返回
            if ((result === null || result === void 0 ? void 0 : result.retcode) === '0') {
                const res = handleFormatRes({
                    result,
                    needParseIntKey,
                    needParseDateKey,
                    transformer: ({ retcode, retmsg, status }) => ({ retcode, retmsg, result: status }),
                });
                return res;
            }
            // 状态码错误的返回
            throw new RespError(result.retcode, result.retmsg, result);
        }
        throw result;
    }
    catch (error) {
        throw error;
    }
}
